
export const compareString = (a, b, valueFn, reverse = false) => {
  if (reverse) {
    return compareString(b, a, valueFn);
  }
  return valueFn(a).localeCompare(valueFn(b));
};

export const compareNumber = (a, b, valueFn, reverse = false) => {
  if (reverse) {
    return compareNumber(b, a, valueFn);
  }
  return valueFn(a) - valueFn(b);
};

export const compareCompetitiveIndex = (a, b, valueFn, reverse = false) => {
  const aVal = valueFn(a);
  const bVal = valueFn(b);
  if (aVal === 0 && bVal === 0) {
    return 0;
  }

  if (aVal !== 0 && bVal === 0) {
    // if the sort order is ascending we want the N/A to be at the end of the list
    return -1;
  }
  if (aVal === 0 && bVal !== 0) {
    return 1;
  }
  return reverse ? bVal - aVal : aVal - bVal;
};

export const getBrandEngagementSortFn = (sortDataType, columnTitle) => {
  let sortFn = sortDataType === 'string' ? compareString : compareNumber;
  if (columnTitle === 'Competitive Index' || columnTitle === 'GasBuddy Rating') {
    sortFn = compareCompetitiveIndex;
  }
  return sortFn;
};

export const getRatingsSortFn = (sortDataType, columnTitle) => getBrandEngagementSortFn(sortDataType, columnTitle);
